import styled from "styled-components";
import { media } from "../../theme/theme";

export const Step1Spacing = styled.div`
    ${media.tablet} {
        padding-bottom: 75px;
    }

    ${media.custom(1140)} {
        padding-bottom: 170px;
    }
`;

export const TrailSVGStep1 = styled.img`
    width: 166px;
    display: block;
    margin: 0 auto 45px;

    ${media.tablet} {
        margin: initial;
        position: absolute;
        width: 100px;
        height: auto;
        left: 50%;
        transform: translate(-50%, -50%);
        top: calc(100% + 40px);
    }

    ${media.custom(1140)} {
        width: 166px;
    }
`;